(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/play-next-draw-dialog.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/play-next-draw-dialog.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const formatTime = svs.utils.date.FormatTime;

function playNextDrawDialog(_ref) {
  let {
    next,
    cancel,
    product,
    regCloseTime,
    isSyndicate
  } = _ref;
  const title = productMapping.isDaySpecificId(product) ? "".concat(productMapping.getDay(product), "ens spel \xE4r st\xE4ngt") : 'Dagens spel är stängt';
  const message = productMapping.isKeno(product) ? "".concat(isSyndicate ? 'Ni' : 'Du', " deltar i morgondagens spelomg\xE5ng.") : "".concat(isSyndicate ? 'Ni' : 'Du', " deltar i n\xE4sta veckas spelomg\xE5ng med dragning ").concat(formatTime('eeee d/M', regCloseTime), ".");
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: message
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Fortsätt',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
svs.numbergames.pay_numbergames.playNextDrawDialog = playNextDrawDialog;

 })(window);